// Third-party
import clsx from 'clsx';

// Constants/Libs/Types
import { MESSAGE_FILTER_META } from '@/components/pages/conversations/SocialInbox/const';
import type { SocialInboxType } from '@/components/pages/conversations/SocialInbox/types';

// Components
import Icon from '@/components/base/Icon';
import useTranslation from 'next-translate/useTranslation';

interface SocialInboxTypeTitleProps {
    selected?: boolean;
    messageFilter: SocialInboxType;
    className?: string;
    classNameTextSize?: string;
}

export const SocialInboxTypeTitle = ({
    selected = false,
    messageFilter,
    className,
    classNameTextSize = 'text-xs'
}: SocialInboxTypeTitleProps) => {
    const { t } = useTranslation('conversations');

    return (
        <div className={clsx('flex items-center space-x-2', className, classNameTextSize)}>
            <Icon
                icon={
                    selected
                        ? MESSAGE_FILTER_META[messageFilter].activeIcon
                        : MESSAGE_FILTER_META[messageFilter].icon
                }
            />
            <span>{t(`tabs.${messageFilter}`)}</span>
        </div>
    );
};
